import React, { useContext, useEffect, useStyles } from 'react';
import { AppContext, DispatchContext } from '../AppContext';
import { Route, Redirect, Switch } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';

import AppGrid from './AppGrid';
import Login from '../containers/Login/Login';
import Register from '../components/Register';
import Quote from '../components/Quote';
import Shop from '../components/Shop';
import Maintenance from '../components/Maintenance';
import Contact from '../components/Contact';
import ResetPassword from '../components/ResetPassword';
import Libtext from '../containers/Libtext/Libtext';
import PermaLink from '../containers/PermaLink/PermaLink';
import Checkout from '../containers/Checkout';
import * as actions from '../actions/actions';
import Service from "../services/service";
import { getBrowserFingerprint, getCookie, setCookie, config } from '../helpers/constants';
import ToastrComponent from '../helpers/toastrComponent';
import FullScreenLoading from '../components/FullScreenLoading';
import UploadForm from '../components/UploadForm';
import WizardPanel from '../components/WizardPanel';


export default function AppRouter(props) {

    const useStyles = makeStyles((theme) => ({
        root: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100vh",
            background: theme.palette.background.image,
            backgroundSize: "cover",
            padding: theme.spacing(2),
            justifyContent: "center",
            alignItems: "center",
            color: "white"
        }
    }));

    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const classes = useStyles();

    const cookieSessionId = getCookie(config.sessionCookieName);

    useEffect(() => {
        if (state.user.sessionId) {
            loadNews();
        }
    }, [state.lang, state.user.sessionId]);

    useEffect(() => {
        Service.setBrowserId(getBrowserFingerprint());
        Service.getProducts().then(response => {
            dispatch(actions.setCheckoutDetails({ products: response.data }));
        });
        Service.getCountries().then(response => {
            dispatch(actions.setCheckoutDetails({ countries: response.data }));
        });
    }, []);

    function loadNews() {
        Service.loadNews().then(res => {
            if (res.success) {
                dispatch(actions.get_news(res || []))
            } else {
                dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
            }
        });
    }


    if (state.ui.redirect) {
        dispatch(actions.reset_navigate());
        if (state.ui.pageName.substring(0, 4) === "http") {
            window.location.href = state.ui.pageName;
            return null;
        }
        return <Redirect push to={state.ui.pageName} />;
    }


    // initial call of app, sessionId not set: try to fetch from cookie
    if (!state.app.maintenance && ((!state.user.sessionId) || (cookieSessionId != state.user.sessionId))) {
        //alert("cookie session id: " + cookieSessionId);
        Service.getUserInfo().then(response => {
            if (response && response.success) {
                setCookie(config.sessionCookieName, response.data.sessionId, 365);
                if (response.data.sessionId != getCookie(config.sessionCookieName)) {
                    alert("Unable to set session cookie. Please make sure to allow cookies in your browser settings.");
                    return null;
                }
                dispatch(actions.setUserDetails(response.data));
            } else {
                dispatch(actions.setMaintenance(true));
            }
        });

        return (
            (state.app.maintenance ? 
            <Maintenance /> :
                <div className={classes.root}>
                    <CircularProgress color="inherit" />
                </div>)
        );
    }

    if (state.app.maintenance || (process.env.REACT_APP_MAINTENANCE == "true")) {
        return (<Maintenance />);
    }

    return (
        <div>
            <ToastrComponent />
            {state.ui.fullScreenLoading && <FullScreenLoading visible={state.ui.fullScreenLoading} text={state.ui.fullScreenLoadingText} />}

            <Switch>
                <Route exact path="/login/:sso?" component={Login} />
                <Route exact path="/quote" component={Quote} />
                <Route exact path="/shop/:prodId?/:origin?" component={Shop} />
                <Route exact path="/wizard" component={WizardPanel} />
                <Route exact path="/contact" component={Contact} />
                <Route exact path="/signup/:lc?" component={Register} />
                <Route exact path="/reset" component={ResetPassword} />
                <Route path="/libtext/:id/:type?" component={Libtext} />
                <Route path="/permalink/:id/:action?" component={PermaLink} />
                <Route path="/upload/:id" component={UploadForm} />
                <Route path="/checkout/:id" component={Checkout} />
                <Route path="/" component={AppGrid} />
            </Switch>
        </div>
    );
}
